module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notAssigned":"Not assigned"},"no":{"notAssigned":"Ikke tildelt"}}')
  delete Component.options._Ctor
}
